import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "footer",
  templateUrl: "./footer.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class FooterComponent {
  currYear: number = new Date().getFullYear();
}
